import React from 'react';
import styles from './rowLoader.module.scss';

export default function RowLoader(props: { loading?: boolean }) {
  return props.loading ? (
    <div className={styles.loader}>
      <div />
    </div>
  ) : null;
}
